import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound = () => {
    return (
        <div className={styles.notFoundContainer}>
            <h1 className={styles.notFoundTitle}>404 - Oops! Lost your route?</h1>
            <p className={styles.notFoundDescription}>
                The page you're looking for doesn't exist.
                Maybe our cab took a wrong turn! 🛺
            </p>
            <Link to="/" className={styles.notFoundFooter}>
                Go Back Home
            </Link>
        </div>
    );
};

export default NotFound;
